<template>
  <div class="om_upload">
    <el-upload
			ref="upload"
      class="upload-demo"
      :class="{ 'limit-upload': limit && value.length >= limit }"
      :list-type="listType"
			:show-file-list="showFileList"
      :disabled="disabled"
      :auto-upload="auto"
      :action="uploadUrl"
      :on-change="handleChange"
      :on-remove="remove"
      :on-success="success"
      :on-preview="preview"
      :file-list="fileList"
      :headers="{Authorization: getToken()}"
      :on-exceed="exceed"
      :before-upload="before"
      :limit="limit"
      :drag="drag"
      :data="paramsData"
    >
      <i v-if="listType == 'picture-card' && !drag" slot="default" class="el-icon-plus" />
      <el-button v-if="listType != 'picture-card' && !drag && isShowBtn" :loading="loading && openLoading" :disabled="disabled" size="small" type="primary" >{{ btnText }}</el-button>
      <slot name="btn"></slot>
			<i v-if="drag" class="el-icon-upload" />
      <div v-if="drag" class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
      <div v-if="tip" slot="tip" class="el-upload__tip" v-html="tip"></div>
      <div v-if="listType == 'picture-card'" slot="file" slot-scope="{file}">
        <el-image
          ref="preview"
          class="el-upload-list__item-thumbnail"
          :src="imageUrl(file)"
          :preview-src-list="[imageUrl(file)]"
          alt=""
        />
        <span class="el-upload-list__item-actions">
          <!-- <span
            class="el-upload-list__item-preview"
            @click="handlePictureCardPreview(file)"
          >
            <i class="el-icon-zoom-in" />
          </span> -->
          <span
            v-if="!disabled && showDown"
            class="el-upload-list__item-delete"
            @click="handleDownload(file)"
          >
            <i class="el-icon-download" />
          </span>
          <span
            v-if="!disabled"
            class="el-upload-list__item-delete"
            @click="handleRemove(file)"
          >
            <i class="el-icon-delete" />
          </span>
        </span>
      </div>
    </el-upload>
    <el-dialog :visible.sync="dialogVisible" append-to-body>
      <img width="100%" :src="dialogImageUrl">
    </el-dialog>
  </div>
</template>

<script>
import { getToken } from '@/utils/auth'
import { download } from '@/api/data'
import { isForbiddenFile, getForbiddenFileTip } from '@/utils/fileType'

export default {
  props: {
    // 双向绑定文件列表
    value: {
      type: Array,
      default: () => {
        return []
      }
    },
    // 文件列表样式text/picture/picture-card
    listType: {
      type: String,
      default: 'text'
    },
		// 显示上传的列表
		showFileList: {
			type: Boolean,
			default: true
		},
    disabled: {
      type: Boolean,
      default: false
    },
    // 是否可以下载图片
    showDown: {
      type: Boolean,
      default: true
    },
    // 提示语
    tip: {
      type: String,
      default: '上传格式受限'
    },
    // 按钮文本
    btnText: {
      type: String,
      default: '点击上传'
    },
    // 是否自动上传
    auto: {
      type: Boolean,
      default: true
    },
    // 允许上传文件个数
    limit: Number,
    accept: {
      type: Array,
      default: () => {
        return []
      }
    },
    drag: {
      type: Boolean,
      default: false
    },
    // 文件:编辑id以及原文件的fileType
    fileGenre: {
      type: Object,
      default: () => {
        return { id: '', fileType: '' }
      }
    },
    // 隐藏按钮
    isShowBtn: {
      type: Boolean,
      default: true
    },
		// 是否开启loading效果
		openLoading: {
			type: Boolean,
			default: true
		},
    // 而外参数
    paramsData: {
      type: Object,
      default: () => {
        return { busType: 'file/business' }
      }
    },
    //文件最大10mb
    maxSize: {
      type: Number,
      default: 10,
    },
    // 上传地址
    uploadUrl: {
      type: String,
      default: process.env.VUE_APP_BASE_API + '/api/manage/file/upload'
    },
    beforeUpload: {
      type: Function,
      default: function() {
        return true
      }
    },
    onError: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      fileList: this.value,
      dialogImageUrl: '', // 预览图片地址
      dialogVisible: false,
			loading: false
    }
  },
  // computed: {
  //   uploadUrl() {
  //     return process.env.VUE_APP_BASE_API + '/api/manage/file/upload'
  //   }
  // },
  watch: {
    value(val) {
      this.fileList = val
    },
    fileList(val) {
      this.$emit('input', val)
    }
  },
  methods: {
    // 文件数量改变
    handleChange(file, fileList) {
      this.$emit('change', file, fileList)
    },
    // 上传成功
    success(response, file, fileList) {
      if (response.code !== 200) {
        this.$message({
          message: response.message + (response.message.includes('系统异常')  ? '' : '，请检查后重新上传'),
          type: 'error',
          duration: 3000
        })
        fileList.splice(fileList.indexOf(file))
        this.onError(response)
      }
      else if (fileList.filter(item => !item.fid).every(item => item.status == 'success')) {
        this.$message({ message: '上传成功', type: 'success' })
        fileList.filter(item => !item.fid).forEach(file => {
          const item = Object.assign(file.response.data, { fid: file.response.data.fid, fileUrl: file.response.data.fileUrl, name: file.name }, this.fileGenre)
          this.fileList.push(item)
          this.$emit('uploadSuccess', item)
        })
      }
      this.loading = false
    },
    // 移除文件
    remove(file, fileList) {
      this.fileList = fileList
      this.$emit('handleChange')
    },
    // 文件格式校验
    before(file) {
      const sizeMb = file.size / 1024 / 1024
      if (this.maxSize < sizeMb) {
         this.$notify({
            title: `只能上传小于${this.maxSize}MB的文件`,
            type: 'warning'
          })
          return false
      }
      // 拦截 html/svg/js/xml/exe/jsp 等存在脚本执行风险的文件类型
      if (isForbiddenFile(file)) {
        this.$notify({
          title: getForbiddenFileTip(file),
          type: 'warning'
        })
        return false
      }
      if(this.listType === 'text') { this.loading = true }
      const arr = file.name.split('.')
      const type = arr[arr.length - 1]
      if (this.accept.length > 0) {
        if (this.accept.indexOf(type.toLowerCase()) === -1) {
          this.$notify({
            title: `只能上传${this.accept.join(',')}格式的文件`,
            type: 'warning'
          })
					this.loading = false
          return false
        }
      }
      return this.beforeUpload()
    },
    // 文件数量超出提示
    exceed(files, fileList) {
      this.$notify({
        title: `只能上传${this.limit}个文件`,
        type: 'warning'
      })
    },
    // 预览
    handlePictureCardPreview(file) {
      // this.dialogImageUrl = this.imageUrl(file)
      // this.dialogVisible = true
      this.$refs.preview.clickHandler()
    },
    // 下载
    handleDownload(fileInfo) {
      window.open(fileInfo.fileUrl);
    },
    // 删除
    handleRemove(file) {
      const idx = this.fileList.findIndex(item => {
        return item.fid === file.fid
      })
      this.fileList.splice(idx, 1)
      this.$emit('handleChange')
    },
    // 点击文件(下载)
    preview(file) {
      window.open(file.fileUrl)
    },
    imageUrl(fileInfo) {
       //oss文件
      if (fileInfo.fileUrl && fileInfo.fileUrl.indexOf('aliyuncs') >= 0) {
        return fileInfo.fileUrl
      }
      // const data = {
      //   result: null
      // }
      // await download(process.env.VUE_APP_BASE_API + '/api/manage/file/download/' + fileInfo.fid).then(data => {
      //   data.result = data
      // }).catch(() => {})

      return process.env.VUE_APP_BASE_API + '/api/manage/file/download/' + fileInfo.fid;
    },
    getToken() {
      return getToken()
    },
		// 打开文件选择
		uploadClick() {
			this.$refs['upload'].$refs['upload-inner'].handleClick()
		},
    // 手动提交上传
    submit() {
      this.$refs['upload'].submit()
    }
  }
}
</script>


<style lang="scss" scoped>
// 隐藏第二个上传卡片
.limit-upload /deep/.el-upload--picture-card {
  display: none;
}
</style>
